var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7071 17.2929C16.3166 16.9024 15.6834 16.9024 15.2929 17.2929C14.9024 17.6834 14.9024 18.3166 15.2929 18.7071L16.7071 17.2929ZM26 28H27C27 27.7348 26.8946 27.4804 26.7071 27.2929L26 28ZM26 42V43C26.5523 43 27 42.5523 27 42H26ZM16 42H15C15 42.5523 15.4477 43 16 43V42ZM17 34C17 33.4477 16.5523 33 16 33C15.4477 33 15 33.4477 15 34H17ZM16 43C16.5523 43 17 42.5523 17 42C17 41.4477 16.5523 41 16 41V43ZM6 42H5C5 42.5523 5.44772 43 6 43V42ZM6 28L5.29289 27.2929C5.10536 27.4804 5 27.7348 5 28H6ZM16.7071 18.7071C17.0976 18.3166 17.0976 17.6834 16.7071 17.2929C16.3166 16.9024 15.6834 16.9024 15.2929 17.2929L16.7071 18.7071ZM17 20C17 20.5523 17.4477 21 18 21C18.5523 21 19 20.5523 19 20H17ZM42 42V43C42.5523 43 43 42.5523 43 42H42ZM26 41C25.4477 41 25 41.4477 25 42C25 42.5523 25.4477 43 26 43V41ZM15.2929 18.7071L25.2929 28.7071L26.7071 27.2929L16.7071 17.2929L15.2929 18.7071ZM25 28V42H27V28H25ZM26 41H16V43H26V41ZM17 42V34H15V42H17ZM16 41H6V43H16V41ZM7 42V28H5V42H7ZM6.70711 28.7071L16.7071 18.7071L15.2929 17.2929L5.29289 27.2929L6.70711 28.7071ZM19 20V8H17V20H19ZM19 8C19 7.44772 19.4477 7 20 7V5C18.3431 5 17 6.34315 17 8H19ZM20 7H40V5H20V7ZM40 7C40.5523 7 41 7.44772 41 8H43C43 6.34315 41.6569 5 40 5V7ZM41 8V42H43V8H41ZM42 41H26V43H42V41Z",
    fill: "#014935"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 14V14.02",
    stroke: "#014935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 14V14.02",
    stroke: "#014935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 22V22.02",
    stroke: "#014935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30V30.02",
    stroke: "#014935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/building-icon.67c5bf8d849c255ff9cce9f011231216.svg";
export { ForwardRef as ReactComponent };